const DEFAULT_GOOGLE_CLIENT_ID =
  "684497180408-ekoug48gp3cm04gik88bvub7a4dvrab2.apps.googleusercontent.com";

const normalizeEnvValue = (value) => String(value ?? "").trim();

export const GOOGLE_CLIENT_ID =
  normalizeEnvValue(process.env.REACT_APP_GOOGLE_CLIENT_ID) ||
  DEFAULT_GOOGLE_CLIENT_ID;

export const GOOGLE_APP_ID =
  normalizeEnvValue(process.env.REACT_APP_GOOGLE_APP_ID) ||
  GOOGLE_CLIENT_ID.split("-")[0];

export const GOOGLE_PICKER_API_KEY = normalizeEnvValue(
  process.env.REACT_APP_GOOGLE_PICKER_API_KEY
);

export const getMaskedGooglePickerApiKey = () => {
  if (!GOOGLE_PICKER_API_KEY) {
    return "(missing)";
  }

  if (GOOGLE_PICKER_API_KEY.length <= 10) {
    return GOOGLE_PICKER_API_KEY;
  }

  return `${GOOGLE_PICKER_API_KEY.slice(0, 6)}...${GOOGLE_PICKER_API_KEY.slice(-4)}`;
};

export const GOOGLE_DRIVE_FILE_SCOPE =
  "https://www.googleapis.com/auth/drive.file";

export const GOOGLE_SPREADSHEET_MIME_TYPE =
  "application/vnd.google-apps.spreadsheet";
